export default "__VITE_ASSET__Wg85j92O__"